import { LoadingStateOptions } from '@atlassian/jira-software-deployments-service-query-types/src/services/types.tsx';
import type { CoreDataActions, CoreDataState } from '../types';

const { LOADING_INITIAL, LOADING_NEXT_PAGE, LOADING_SET_VARIABLES, READY, HAS_ERROR } =
	LoadingStateOptions;

export const initialState: CoreDataState = {
	coreData: null,
	error: null,
	loadingState: LOADING_INITIAL,
	numIssuePages: 1,
	hasNextIssuePage: false,
	hasReachedMaxDeploymentsLimit: false,
};
export const coreDataReducer = (state: CoreDataState, action: CoreDataActions) => {
	switch (action.type) {
		case 'fetchTriggered':
			return {
				...state,
				loadingState: state.loadingState === LOADING_INITIAL ? LOADING_INITIAL : LOADING_NEXT_PAGE,
			};
		case 'fetchSuccess':
			return {
				...state,
				coreData: action.payload.coreData,
				hasNextIssuePage: action.payload.hasNextIssuePage,
				hasReachedMaxDeploymentsLimit: action.payload.hasReachedMaxDeploymentsLimit,
				loadingState: READY,
			};
		case 'fetchFailed':
			return {
				...state,
				error: action.payload,
				loadingState: HAS_ERROR,
				numIssuePages:
					state.loadingState === LOADING_NEXT_PAGE ? state.numIssuePages - 1 : state.numIssuePages,
			};
		case 'fetchMore':
			return {
				...state,
				error: null,
				numIssuePages: state.numIssuePages + 1,
			};
		case 'filterChanged':
			if (state.loadingState === LOADING_INITIAL) {
				return state;
			}

			return {
				...state,
				error: null,
				loadingState: LOADING_SET_VARIABLES,
				numIssuePages: 1,
			};
		default:
			// prettier-ignore
			// @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			(action.type as never);
			throw Error('Unhandled core data provider action');
	}
};
